// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 start
import { RootState } from 'types';

export const newentrantSendoffSelector = (state: RootState) => state.newentrantSendoffContainer;
// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 end
